import constants from "../../constants";
import { translate } from "../../Services/translation";

export function generate(isB2C, deliveryAddressCountries) {
    if (isB2C) {
        return generateB2C(deliveryAddressCountries);
    }

    return generateB2B(deliveryAddressCountries);
}

function generateAddressFields(key, deliveryAddressCountries) {
    return [
        {
            name: `${key}.address1`,
            label: translate("checkout.form.address.label"),
            placeholder: translate("checkout.form.address.placeholder"),
            type: 'text'
        },
        {
            name: `${key}.careOf`,
            label: translate("checkout.form.careof.label"),
            placeholder: translate("checkout.form.careof.placeholder"),
            type: 'text'
        },
        {
            name: `${key}.zipCode`,
            label: translate("checkout.form.zipcode.label"),
            placeholder: translate("checkout.form.zipcode.placeholder"),
            type: 'text'
        },
        {
            name: `${key}.city`,
            label: translate("checkout.form.city.label"),
            placeholder: translate("checkout.form.city.placeholder"),
            type: 'text'
        },
        {
            name: `${key}.country`,
            label: translate("checkout.form.country.label"),
            placeholder: translate("checkout.form.country.placeholder"),
            type: 'country',
            countries: constants.countries.filter(x => {
                if (deliveryAddressCountries.length > 0) {
                    return deliveryAddressCountries.includes(x.value);
                }

                return true;
            })
        },
        {
            name: `${key}.state`,
            key: "state",
            label: translate("checkout.form.state.label"),
            placeholder: translate("checkout.form.state.placeholder"),
            type: 'state',
            dependsOn: `${key}.country`
        },
    ];
}

function generateBusinessUserSpecificFields() {
    return [

        {
            key: "deliveryAddress",
            label: translate("checkout.forms.deliveryaddresses"),
            placeholder: translate("checkout.forms.deliveryaddresses.placeholder"),
            name: 'deliveryAddress',
            type: 'deliveryAddress'
        },
        {
            key: "companyName",
            label: translate("checkout.customerinfo.companyname"),
            placeholder: translate("checkout.form.companyname.placeholder"),
            name: 'companyName',
            type: 'text'
        }
    ]
}

function generateB2B(deliveryAddressCountries) {
    return [
        {
            title: "checkout.form.contactinformation",
            key: 'customerDetails',
            fields: getContactInformationFields(),
        },
        {
            title: "checkout.form.shippingaddress",
            key: 'shippingAddress',
            fields: generateBusinessUserSpecificFields()
                .concat(generateAddressFields('shippingAddress', deliveryAddressCountries)),
        },
        {
            title: "checkout.form.billingaddress",
            key: 'billingAddress',
            fields: generateAddressFields('billingAddress', deliveryAddressCountries),
        },
    ];
}


function getContactInformationFields() {
    return [
        {
            label: translate("checkout.form.firstname.label"),
            placeholder: translate("checkout.form.firstname.placeholder"),
            name: 'customerDetails.firstName',
            type: 'text'
        },
        {
            label: translate("checkout.form.lastname.label"),
            placeholder: translate("checkout.form.lastname.placeholder"),
            name: 'customerDetails.lastName',
            type: 'text'
        },
        {
            label: translate("checkout.form.email.label"),
            placeholder: translate("checkout.form.email.placeholder"),
            name: 'customerDetails.email',
            type: 'text'
        },
        {
            label: translate("checkout.form.phonenumber.label"),
            placeholder: translate("checkout.form.phonenumber.placeholder"),
            name: 'customerDetails.phoneNumber',
            type: 'text'
        }
    ];
}

function generateB2C(deliveryAddressCountries) {
    return [
        {
            title: "checkout.form.contactinformation",
            key: 'customerDetails',
            fields: getContactInformationFields(),
        },
        {
            title: "checkout.form.billingaddress",
            key: 'billingAddress',
            fields: generateAddressFields('billingAddress', deliveryAddressCountries),
        },
        {
            title: "checkout.form.shippingaddress",
            key: 'shippingAddress',
            fields: generateAddressFields('shippingAddress', deliveryAddressCountries),
        },
    ];
}
